import Avatar from "../components/Avatar";
import { truncate } from "../helpers";
 
export default function ChatListItem({ chat, isActive, onClick }) {
  return (
    <div
      onClick={() => onClick(chat)}
      style={{
        ...styles.row,
        background: isActive ? "#515358ff" : "#191818ff",
        borderLeft: isActive ? "3px solid #1a3c5e" : "3px solid transparent",
      }}
      onMouseEnter={(e) => {
        if (!isActive) e.currentTarget.style.background = "#191818ff";
      }}
      onMouseLeave={(e) => {
        if (!isActive) e.currentTarget.style.background = "#191818ff";
      }}
    >
      {/* Avatar */}
      <Avatar
        initials={chat.initials}
        color={chat.avatarColor}
        size={42}
        showOnline={chat.isOnline}
      />
 
      {/* Text content */}
      <div style={styles.content}>
        <div style={styles.topRow}>
          <span style={styles.name}>{chat.name}</span>
          <span style={styles.time}>{chat.time}</span>
        </div>
        <div style={styles.bottomRow}>
          <span style={styles.preview}>{truncate(chat.lastMsg, 36)}</span>
          {chat.unread > 0 && (
            <span style={styles.badge}>{chat.unread}</span>
          )}
        </div>
      </div>
    </div>
  );
}
 
const styles = {
  row: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px 10px 9px",
    cursor: "pointer",
    borderBottom: "1px solid #191818ff",
    transition: "background 0.1s",
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    marginBottom: 3,
  },
  name: {
    fontSize: 14,
    fontWeight: 600,
    color: "#ffffffff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 150,
  },
  time: {
    fontSize: 11,
    color: "#94a3b8",
    whiteSpace: "nowrap",
    marginLeft: 6,
  },
  bottomRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  preview: {
    fontSize: 12,
    color: "#a7a7a7ff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1,
  },
  badge: {
    minWidth: 18,
    height: 18,
    borderRadius: 9,
    background: "#68f060ff",
    color: "#191818ff",
    fontSize: 11,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 5px",
    marginLeft: 6,
    flexShrink: 0,
  },
};